export const ASSIGNMENT_A_TO_Z = "assignment_a_to_z";
export const ASSIGNMENT_Z_TO_A = "assignment_z_to_a";
export const COURSE_A_TO_Z = "course_a_to_z";
export const COURSE_Z_TO_A = "course_z_to_a";
export const NEW_HIGH_TO_LOW = "new_high_to_low";
export const NEW_LOW_TO_HIGH = "new_low_to_high";
export const AVG_LOW_TO_HIGH = "average_low_to_high";
export const AVG_HIGH_TO_LOW = "average_high_to_low";
